import { forwardRef, useEffect } from 'react';
import { useIMask } from 'react-imask';
import { mergeRefs } from '@/shared/lib/utils/merge-refs';
import FormInput from '../FormInput';
import { Props as InputProps } from '../Input/Input';

interface Props extends InputProps {
    /**
     * Коллбэк на изменение значения,
     * в параметре функции возвращается форматированное значение
     */
    onPhoneChange?: (value: string) => void;
}

const PhoneInput = forwardRef<HTMLInputElement, Props>(
    ({ onPhoneChange, value, defaultValue, onChange, onInput, ...props }, ref) => {
        const initialValue =
            typeof value === 'string' ? value : typeof defaultValue === 'string' ? defaultValue : undefined;

        const {
            ref: maskRef,
            value: maskValue,
            setValue,
        } = useIMask(
            { mask: `+${'0'.repeat(14)}` },
            {
                defaultValue: initialValue,
                onAccept: (acceptedValue) => {
                    onPhoneChange?.(acceptedValue);
                },
            },
        );

        useEffect(() => {
            if (typeof value === 'string' && value !== maskValue) {
                setValue(value);
            }
        }, [value, maskValue, setValue]);

        return <FormInput {...props} ref={mergeRefs([ref, maskRef])} type="tel" />;
    },
);

PhoneInput.displayName = 'PhoneInput';

export default PhoneInput;
